import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  noPadding?: boolean;
  interactive?: boolean;
}
export function Card({
  children,
  className = '',
  onClick,
  noPadding = false,
  interactive = false
}: CardProps) {
  return <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 ${!noPadding ? 'p-4 lg:p-6' : ''} ${interactive ? 'cursor-pointer transition-all duration-200 hover:shadow-md' : ''} ${className}`} onClick={onClick} data-id="element-964">
      {children}
    </div>;
}